import axios from 'axios';

const ENV = process.env.REACT_APP_ENVIRONMENT;

const BASE_URL =
  ENV === 'prod'
    ? 'https://pethouse-backend.onrender.com'
    : 'http://localhost:5000';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export { BASE_URL };
export default axiosInstance;
